import Vue from 'vue'
import Router from 'vue-router'
import routes from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'
import config from '@/config'

Vue.use(Router)

const RouterLayout = createRouterLayout(layout => {
  const warehouseId = config.warehouseId
  if (warehouseId) {
    if (layout === 'default') {
      layout = 'newdefault'
      return import('@/layouts/' + layout + '.vue')
    }
  }
  return import('@/layouts/' + layout + '.vue')
})

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }), // 滚动条滚动到顶部 切换页面
  routes: [
    {
      path: '/',
      component: RouterLayout,
      children: routes
    },
    {
      path: '/error',
      redirect: '/exception/404'
    },
    {
      path: '*',
      redirect: '/exception/404'
    }
  ]
})

export default router
